const T = {
  /**
   * Event for modifying browser history
   */
  HISTORY_ACTION: "HISTORY_ACTION",
  /**
   * Track event in GTM or similar
   */
  TRACK_EVENT: "TRACK_EVENT"
};
export {
  T as EVENT
};
